/* Define your initial state here.
 *
 * If you change the type from object to something else, do not forget to update
 * src/container/App.js accordingly.
 */
import * as types from "../actions/action-types";

const initialState = {
  bookMarksdata: { driver: [], vehicle: [] },
  fetchingBookmarks: false
};

const reducer = (state = initialState, action = {}) => {
  /* Keep the reducer clean - do not mutate the original state. */
  // const nextState = Object.assign({}, state);

  switch (action.type) {
    case `${types.BOOKMARKS_GET}_PENDING`: {
      return Object.assign({}, state, {
        fetchingBookmarks: true
      });
    }
    case `${types.BOOKMARKS_GET}_FULFILLED`: {
      return Object.assign({}, state, {
        fetchingBookmarks: false,
        bookMarksdata: {
          driver: action.payload.driver,
          vehicle: action.payload.vehicle
        }
      });
    }
    case `${types.BOOKMARKS_GET}_REJECTED`: {
      return {
        isRejected: true,
        error: "Get Driver Profile Failed"
      };
    }

    default: {
      /* Return original state if no actions were consumed. */
      return state;
    }
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/common/Bookmarks/reducer/index.js